import * as React from "react";
import type { SVGProps } from "react";
const SvgSlidersInSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 17c0 .55.45 1 1 1s1-.45 1-1v-6c.55 0 1-.45 1-1s-.45-1-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v2c-.55 0-1 .45-1 1s.45 1 1 1zM12 18c-.55 0-1-.45-1-1v-1c-.55 0-1-.45-1-1s.45-1 1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c.55 0 1 .45 1 1s-.45 1-1 1v1c0 .55-.45 1-1 1M16 18c-.55 0-1-.45-1-1v-5c-.55 0-1-.45-1-1s.45-1 1-1V7c0-.55.45-1 1-1s1 .45 1 1v3c.55 0 1 .45 1 1s-.45 1-1 1v5c0 .55-.45 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 18c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6C3.79 2 2 3.79 2 6zM4 6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSlidersInSquare;
